import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../services/api';
import { AnswerRecords } from '.';
import { AnswerRecord } from '../../types/AnswerRecordType';
import { LoadingContext } from '../../providers/loading';

export function AnswerRecordsContainer() {
  const { contractId, projectId } = useParams();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [answerRecord, setAnswerRecord] = useState<AnswerRecord[]>([]);

  async function getAnswersRecordData() {
    setIsLoading({ value: true });
    await api.get(`/project/${projectId}/answers`)
      .then((response) => {
        setAnswerRecord(response?.data);
        setIsLoading({ value: false });
      })
      .catch(() => {
        setIsLoading({ value: false });
      });
  }

  useEffect(() => {
    getAnswersRecordData();
  }, []);

  return (
    <AnswerRecords
      answerRecordData={answerRecord}
      isLoading={isLoading.value}
      contractId={contractId}
      projectId={projectId}
    />
  );
}
